import React from "react";

interface CardInfoProps {
    icon: any;
    label: string | number;
    labelClass: string;
}

const CardInfo = ({label, labelClass, icon }: CardInfoProps) => {
    const displayLabel =
      label !== null && typeof label === "object"
        ? ""
        : label ?? "";

    return (
            <div className={"flex justify-between items-center h-10 w-full"}>
                <div className={`text-2xl font-bold ${labelClass}`}>{displayLabel}</div>
                {icon}
            </div>
    );
};

export default CardInfo;
